import BookingComplete from './BookingComplete';

export default BookingComplete;
